// Redux UI slice for app-wide UI state
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  sidebarCollapsed: boolean;
  projectHeaderFullscreen: boolean;
}

const initialState: UIState = {
  sidebarCollapsed: false,
  projectHeaderFullscreen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    setProjectHeaderFullscreen(state, action: PayloadAction<boolean>) {
      state.projectHeaderFullscreen = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarCollapsed, setProjectHeaderFullscreen } = uiSlice.actions;
export default uiSlice.reducer;

